export function decimalToTime(value?: number) {
  if (!value) return '-';

  const horas = Math.floor(value);
  const minutos = Math.round((value - horas) * 60);
  return `${horas}:${String(minutos).padStart(2, '0')}h`;
}
